// ignore-string-externalization
import { white, gray20 } from '@spotify-internal/encore-foundation';
export { gold } from '@spotify-internal/encore-foundation';
export { kleinBlue } from '@spotify-internal/encore-foundation';
export var goldHighlight = '#fbb250';
export var goldActive = '#d58010';
export var gridGutterWidth = '30px';
export var containerSm = "".concat(720 + parseInt(gridGutterWidth, 10), "px");
export var containerMd = "".concat(940 + parseInt(gridGutterWidth, 10), "px");
export var containerLg = "".concat(1140 + parseInt(gridGutterWidth, 10), "px");
export var zIndexNavbar = 1000;
export var navbarXsHeight = '54px';
export var navbarHeight = '80px';
export var navbarDefaultLinkColor = white;
export var fontFamilyBase = 'spotify-circular, @font-family-sans-serif';
export var fontWeightBook = 400;
export var fontWeightBold = 700;
export var fontWeightBlack = 900;
export var fontSizeH3 = '20px';
export var fontWeightH3 = fontWeightBlack;
export var lineHeightH3 = 1.4;
export var fontSizeH3Sm = '24px';
export var letterSpacingH3Sm = '-0.01em';
export var textColor = gray20;
export var btnLineHeight = 1;
export var btnFontSizeLg = '16px';
export var btnPaddingLargeVertical = '20px';
export var btnPaddingLargeHorizontal = "".concat(Math.floor(parseInt(btnFontSizeLg, 10) * btnLineHeight + parseInt(btnPaddingLargeVertical, 10) * 2), "px");